import { Id_floor } from "./api/Identifiers";

export class Floor {
    public id: Id_floor = null;
    public label: string = "";
    public z_index: number = -1;

    public constructor() {
    }

    public static build(id_floor: Id_floor, label: string, z_index: number): Floor {
        let r: Floor = new Floor();
        r.id = id_floor;
        r.label = label;
        r.z_index = z_index;
        return r;
    }
}

export class FloorsCollection {
    private _floors_tree: any = {};

    public static empty(): FloorsCollection {
        return new FloorsCollection();
    }
    public get floors(): Floor[] {
        let r: Floor[] = [];

        for (let key in this._floors_tree) {
            r.push(this._floors_tree[key]);
        }

        // always return this list sorted
        r.sort(function (lhs: Floor, rhs: Floor) {
            return (lhs.z_index > rhs.z_index) ? 1 : ((rhs.z_index > lhs.z_index) ? -1 : 0);
        });

        return r;
    }
    public add(floor: Floor) {
        this._floors_tree[floor.id.value] = floor;
    }
}